import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_36689_1330)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.99961 11.3996C8.98195 11.3996 11.3996 8.98195 11.3996 5.99961C11.3996 3.01727 8.98195 0.599609 5.99961 0.599609C3.01727 0.599609 0.599609 3.01727 0.599609 5.99961C0.599609 8.98195 3.01727 11.3996 5.99961 11.3996Z",
				fill: "#B40030",
				stroke: "#B40030",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 6.375V3.75",
				stroke: "white",
				strokeWidth: .75,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 7.52344C6.29772 7.52344 6.53906 7.76478 6.53906 8.0625C6.53906 8.36022 6.29772 8.60156 6 8.60156C5.70228 8.60156 5.46094 8.36022 5.46094 8.0625C5.46094 7.76478 5.70228 7.52344 6 7.52344Z",
				fill: "white",
				stroke: "white",
				strokeWidth: .046875
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_36689_1330",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}) })]
});
export default SvgErrorFilled;
